import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  changeTrainerPopup: {
    "& .MuiDialogTitle-root": {
      paddingTop: 40,
      paddingBottom: 25,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        padding: "16px 22px"
      }
    },
    "& .MuiDialog-paper": {
      height: 370
    }
  },
  horseSummaryRoot: {
    height: 118,
    padding: "14px 30px 26px 20px",
    marginTop: 15,
    filter: "drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.06))",
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      height: "auto"
    }
  },
  horseSummaryInfo: {
    height: "100%",
    justifyContent: "space-around",
    "& div": {
      fontSize: 16
    },
    "& div:first-Child": {
      fontSize: 18
    },
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      "& div, div:first-Child": {
        fontSize: 14
      }
    }
  },
  summaryTitleWrapper: {
    display: "flex",
    alignItems: "center"
  },
  rightArrow: {
    margin: "0 16px"
  }
}));
